import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PresMovimientosDetComponent } from '../pres-movimientos-det/pres-movimientos-det.component'

@Component({
  selector: 'app-pres-movimientos',
  templateUrl: './pres-movimientos.component.html',
  styleUrls: ['./pres-movimientos.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class PresMovimientosComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
 
  arrArbol:any=[];
  arbol:any=[];
  arbolIng:any=[];
  arbolEg:any=[];
  importe:number=0;
  fecha:string="";
  nota:string="";
  ultMov:any=[];

  thisForm = new FormGroup({
    buscaIng: new FormControl('', []),
    buscaEg: new FormControl('', []),
    importe: new FormControl(this.importe, [Validators.required]),
    fecha: new FormControl(this.fecha, [Validators.required]),
    nota: new FormControl(this.nota, []),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<PresMovimientosDetComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.dataService.getPres_Arbol(3, '1', null).subscribe(
                    rows => {   
                            this.arrArbol = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnArbolIngCargado());
   this.dataService.getPres_UltMov(15, '%', '%').subscribe(
                    rows => {   
                            this.ultMov = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnUltimosMovsCargados());                    
  }

  fnUltimosMovsCargados(){
    console.log(this.ultMov);
  }

  fnArbolIngCargado(){
    console.log(this.arrArbol)
    this.arbol = [];
    this.arbol.push({'tipo':'INGRESO',
                     'conceptos':[],
                     'ver': true,
                     'total':0
                    },{'tipo':'EGRESO',
                     'conceptos':[],
                     'ver': true,
                     'total':0
                    })
    var ingEgre = -1;
    for(var i = 0; i < this.arrArbol.length; i++){
        ingEgre = this.arrArbol[i].tipo == "INGRESO" ? 0 : 1;
        if(i == 0){                                                          //--> PRIMER CONCEPTO
            this.fnAgregaNodoN1(this.arrArbol[i], ingEgre);
            if(this.arrArbol[i].idN2 != null){
                this.fnAgregaNodoN2(this.arrArbol[i], ingEgre)
                if(this.arrArbol[i].idN3 != null){
                    this.fnAgregaNodoN3(this.arrArbol[i], ingEgre)
                }
            }
        }
        else{                                                               //--> RESTO
            //console.log(this.arrArbol[i].idN1 + " != " + this.arrArbol[i-1].idN1);
            if(this.arrArbol[i].idN1 != this.arrArbol[i-1].idN1){                //--> VALIDAR QUE NO EXISTA EL CONCEPTO (N1)
                this.fnAgregaNodoN1(this.arrArbol[i], ingEgre);
                if(this.arrArbol[i].idN2 != null){
                    this.fnAgregaNodoN2(this.arrArbol[i], ingEgre)
                    if(this.arrArbol[i].idN3 != null){
                        this.fnAgregaNodoN3(this.arrArbol[i], ingEgre)
                    }
                }    
            }
            else{
                if(this.arrArbol[i].idN2 != this.arrArbol[i-1].idN2){                //--> VALIDAR QUE NO EXISTA EL SUBCONCEPTO (N2)
                    this.fnAgregaNodoN2(this.arrArbol[i], ingEgre)
                    if(this.arrArbol[i].idN3 != null){
                        this.fnAgregaNodoN3(this.arrArbol[i], ingEgre)
                    }
                }
                else{
                    if(this.arrArbol[i].idN3 != null){
                        this.fnAgregaNodoN3(this.arrArbol[i], ingEgre) 
                    }                  
                }    
            }                
        }
        
    }
    //console.log(this.arbol);
    this.arbolIng = this.arbol[0];
    this.arbolEg = this.arbol[1];
  }

  fnAgregaNodoN1(item:any, ingEgre){
    this.arbol[ingEgre].conceptos.push({'idN1': item.idN1,
                                        'actN1': item.actN1,
                                        'padre': item.tipo,
                                        'concepto': item.concepto,
                                        'lblConcepto': item.lblConcepto,
                                        'subconceptos':[],
                                        'preCarga': item.preCarga == "SI" ? true : false,
                                        'ver': true,
                                        'filtrado': false,
                                        'total': 0
                                      })
  }

  fnAgregaNodoN2(item:any, ingEgre){
    this.arbol[ingEgre].conceptos[this.arbol[ingEgre].conceptos.length - 1].subconceptos.push({'idN2': item.idN2,
                                                  'actN2': item.actN2,
                                                  'tipo': item.tipo,
                                                  'padre': item.concepto,
                                                  'subconcepto': item.subconcepto,
                                                  'lblSubconcepto': item.lblSubconcepto,
                                                  'nota': item.nota,
                                                  'detalles':[],
                                                  'ver': true,
                                                  'filtrado': false,
                                                  'total': 0
                                                })  
  }

  fnAgregaNodoN3(item:any, ingEgre){
    var auxIndex = this.arbol[ingEgre].conceptos[this.arbol[ingEgre].conceptos.length - 1].subconceptos.length;
    console.log(auxIndex);
    this.arbol[ingEgre].conceptos[this.arbol[ingEgre].conceptos.length - 1].subconceptos[auxIndex - 1].detalles.push({'idN3': item.idN3,
                                                            'actN3': item.actN3,
                                                            'tipo': item.tipo,
                                                            'abuelo': item.concepto,
                                                            'padre': item.subconcepto,
                                                            'idN2': item.idN2,
                                                            'detalle': item.detalle,
                                                            'filtrado': false,
                                                            'total': 0
                                                          })  
  }


  fnKeyPress(t, e){
    console.log("KeyPress");
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else{
      return true;
    }
  }

  fnKeyUp(t){
    //console.log(e);
    console.log("KeyUp");
    var auxTxt;
    auxTxt = <HTMLInputElement>document.getElementById("txtIng");
    //console.log(auxTxt.value);
    if(t=="INGRESO"){
      for(var i = 0; i < this.arbolIng.conceptos.length; i++){
        //console.log((this.arbolIng.conceptos[i]));
        this.arbolIng.conceptos[i].filtrado = true;
        //--> Tiene hijos
        if(this.arbolIng.conceptos[i].subconceptos.length > 0){
          for(var j = 0; j < this.arbolIng.conceptos[i].subconceptos.length; j++){
            //console.log((this.arbolIng.conceptos[i].subconceptos[j]));
            this.arbolIng.conceptos[i].subconceptos[j].filtrado = true;
            //--> Tiene hijos
            if(this.arbolIng.conceptos[i].subconceptos[j].detalles.length > 0){
              for(var k = 0; k < this.arbolIng.conceptos[i].subconceptos[j].detalles.length; k++){
                //console.log((this.arbolIng.conceptos[i].subconceptos[j].detalles[k]));
                this.arbolIng.conceptos[i].subconceptos[j].detalles[k].filtrado = true;
                //console.log(this.arbolIng.conceptos[i].subconceptos[j].detalles[k].detalle.toUpperCase())
                if(this.arbolIng.conceptos[i].subconceptos[j].detalles[k].detalle.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0){
                  //console.log("COINCIDE N3!")
                  this.arbolIng.conceptos[i].subconceptos[j].detalles[k].filtrado = false
                  //--> Mostrar padre y abuelo
                  this.arbolIng.conceptos[i].subconceptos[j].filtrado = false;
                  this.arbolIng.conceptos[i].filtrado = false;
                }  
              }
            }
            //--> Sin hijos, de no tener coincidencia en cadena; excluir
            else{
              //console.log(this.arbolIng.conceptos[i].subconceptos[j].subconcepto.toUpperCase() + " || " + this.arbolIng.conceptos[i].subconceptos[j].lblSubconcepto.toUpperCase())
              if(this.arbolIng.conceptos[i].subconceptos[j].subconcepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 || this.arbolIng.conceptos[i].subconceptos[j].lblSubconcepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 ){
                //console.log("COINCIDE N2!")
                this.arbolIng.conceptos[i].subconceptos[j].filtrado = false
                //--> Mostrar padre 
                this.arbolIng.conceptos[i].filtrado = false;
              }
            }
          }
        }
        //--> Sin hijos, de no tener coincidencia en cadena; excluir
        else{
          //console.log(this.arbolIng.conceptos[i].concepto.toUpperCase() + " || " + this.arbolIng.conceptos[i].lblConcepto.toUpperCase())
          if(this.arbolIng.conceptos[i].concepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 || this.arbolIng.conceptos[i].lblConcepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 ){
            //console.log("COINCIDE N1!")
            this.arbolIng.conceptos[i].filtrado = false
          }
        }
      }
      //console.log(this.arbolIng);
    }
    else{
      auxTxt = <HTMLInputElement>document.getElementById("txtEg");
      for(var i = 0; i < this.arbolEg.conceptos.length; i++){
        //console.log((this.arbolEg.conceptos[i]));
        this.arbolEg.conceptos[i].filtrado = true;
        //--> Tiene hijos
        if(this.arbolEg.conceptos[i].subconceptos.length > 0){
          for(var j = 0; j < this.arbolEg.conceptos[i].subconceptos.length; j++){
            console.log((this.arbolEg.conceptos[i].subconceptos[j]));
            this.arbolEg.conceptos[i].subconceptos[j].filtrado = true;
            //--> Tiene hijos
            if(this.arbolEg.conceptos[i].subconceptos[j].detalles.length > 0){
              for(var k = 0; k < this.arbolEg.conceptos[i].subconceptos[j].detalles.length; k++){
                //console.log((this.arbolEg.conceptos[i].subconceptos[j].detalles[k]));
                this.arbolEg.conceptos[i].subconceptos[j].detalles[k].filtrado = true;
                //console.log(this.arbolEg.conceptos[i].subconceptos[j].detalles[k].detalle.toUpperCase())
                if(this.arbolEg.conceptos[i].subconceptos[j].detalles[k].detalle.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0){
                  //console.log("COINCIDE N3!")
                  this.arbolEg.conceptos[i].subconceptos[j].detalles[k].filtrado = false
                  //--> Mostrar padre y abuelo
                  this.arbolEg.conceptos[i].subconceptos[j].filtrado = false;
                  this.arbolEg.conceptos[i].filtrado = false;
                }  
              }
            }
            //--> Sin hijos, de no tener coincidencia en cadena; excluir
            else{
              //console.log(this.arbolEg.conceptos[i].subconceptos[j].subconcepto.toUpperCase() + " || " + this.arbolEg.conceptos[i].subconceptos[j].lblSubconcepto.toUpperCase())
              if(this.arbolEg.conceptos[i].subconceptos[j].subconcepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 || this.arbolEg.conceptos[i].subconceptos[j].lblSubconcepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 ){
                //console.log("COINCIDE N2!")
                this.arbolEg.conceptos[i].subconceptos[j].filtrado = false
                //--> Mostrar padre 
                this.arbolEg.conceptos[i].filtrado = false;
              }
            }
          }
        }
        //--> Sin hijos, de no tener coincidencia en cadena; excluir
        else{
          //console.log(this.arbolEg.conceptos[i].concepto.toUpperCase() + " || " + this.arbolEg.conceptos[i].lblConcepto.toUpperCase())
          if(this.arbolEg.conceptos[i].concepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 || this.arbolEg.conceptos[i].lblConcepto.toUpperCase().indexOf(auxTxt.value.toUpperCase()) >= 0 ){
            //console.log("COINCIDE N1!")
            this.arbolEg.conceptos[i].filtrado = false
          }
        }
      }
      //console.log(this.arbolEg);
    }
  }

  fnIngresarMovimiento(nivel:number, item:any){
    console.log(item);
    let dialogRef = this.dialog.open(PresMovimientosDetComponent, {
                                      width: "600px",
                                      data: { 
                                            nivel:nivel,
                                            id: nivel == 1 ? item.idN1 : (nivel == 2 ? item.idN2 :  item.idN3),
                                            item:item
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    //this.fnInicio();
                                    }); 
  }

}
